import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {getNiumRemitterInfo} from './remitter/mock';

import {
  TPaymentInfo, TPaymentInfoStatus, TNium, TGroupPlan,
} from './types';
import {getBeneficiary} from './beneficiary/mock';
import {Nium, TGroup, TGroupStatus} from '../types';
import {getKrakenPayoutList} from '../kraken/mock';
import {TKraken} from '../kraken/types';

const amount = faker.finance.amount;

type TGroupPlanParams = {currency?: string};
export type TNiumGroupParams = {groupPlan?: TGroupPlanParams};
export const getNiumGroup = (params: TNiumGroupParams): TGroup<Nium> => {
  const krakenPayoutList = getKrakenPayoutList(faker.mersenne.rand(5, 1)) as TKraken[];
  const payoutList = getNiumList(faker.mersenne.rand(10, 1)) as TNium[];
  const total = payoutList.reduce((acc, {amount}) => Number(acc += Number(amount)), 0);
  const statuses = [
    'FundsRequested',
    'FundsReceivedByNium',
    'FailedToTransferFunds',
    'PayoutsInProcess',
    'Complete',
    'Canceled',
  ] as TGroupStatus[];
  const groupPlanParams = params.groupPlan || {};

  return {
    id: faker.datatype.uuid(),
    amount: String(total),
    fee: amount(0, total, 2),
    expected_total_fees: amount(0, total, 2),
    kraken_withdraws: krakenPayoutList,
    flow: 'v3_via_nium_direct',
    flow_details: {
      group_plan: getGroupPlan(groupPlanParams),
      payouts: payoutList,
    },
    mode: (faker.helpers as any).arrayElement(['Manual', 'Auto']) as 'Manual' | 'Auto',
    status: (faker.helpers as any).arrayElement(statuses) as TGroupStatus,
    errors: [],
    created_at: faker.date.recent().toISOString(),
  } as TGroup<Nium>;
};

export const getGroupPlan = (params: TGroupPlanParams = {}): TGroupPlan => {
  const exchangeList = ['kraken'];

  return {
    id: faker.datatype.uuid(),
    nium_account_id: faker.datatype.uuid(),
    payout_currency: params.currency || faker.finance.currencyCode(),
    payout_fee: amount(0, 1000, 2),
    payout_amount: amount(0, 1000, 2),
    exchange: (faker.helpers as any).arrayElement(exchangeList),
  };
};

export const getPaymentInfo = (): TPaymentInfo => {
  const statuses = [
    'IN_PROCESS',
    'AWAITING_FUNDS',
    'COMPILANCE_VERIFICATION',
    'COMPILANCE_REJECTED',
    'COMPILANCE_APPROVED',
    'INFO_REQUESTED',
    'PG_PROCESSING',
    'PAID',
    'RETURNED',
    'CANCELED',
    'ERROR',
    'USER_REJECTED',
  ] as TPaymentInfoStatus[];

  return {
    id: faker.datatype.uuid(),
    tx_number: faker.datatype.uuid(),
    remitter: getNiumRemitterInfo(),
    beneficiary: getBeneficiary(),
    status: (faker.helpers as any).arrayElement(statuses),
    sub_status: faker.lorem.lines(),
    status_description: faker.lorem.lines(),
    created_at: faker.date.recent().toISOString(),
    updated_at: faker.date.recent().toISOString(),
  } as TPaymentInfo;
};

export const getNiumList = (limit: number = 5): TNium[] => {
  const currency = faker.finance.currencyCode();
  return loopMap(limit, () => getNium(currency)) as TNium[];
};

export const getNium = (currency): TNium => {
  const statuses = ['Manual', 'Automatic', 'Error'];
  const progresses = [
    'IntermediateDelivery',
    'AtIntermediateService',
    'MerchantDelivery',
    'Delivered',
    'Canceled',
  ];
  const count = faker.mersenne.rand(5, 1);
  const transactions = loopMap(count, getPaymentInfo) as TPaymentInfo[];

  return {
    id: faker.datatype.uuid(),
    merchant_id: faker.datatype.uuid(),
    merchant_name: faker.name.findName(),
    merchant_email: faker.internet.email(),
    amount: amount(0, 1000, 2),
    fee: amount(0, 1000, 2),
    currency: currency || faker.finance.currencyCode(),
    status: (faker.helpers as any).arrayElement(statuses),
    progress: (faker.helpers as any).arrayElement(progresses),
    tx_attempts: transactions,
  } as TNium;
};
